export var INTERNAL_ERROR = 0;
export var INSUFFICIENT_FUNDS = 1;
export var FACTORS_CHANGED = 2;
export var ACCOUNT_LOCKED = 3;
export var SYSTEM_NOT_ALLOWED_FOR_FREEBET = 4;
export var INCORRECT_STAKE = 5;
export var MIN_STAKE_AMOUNT = 6;
export var INCORRECT_VIRTUAL_STAKE = 7;
export var INCORRECT_FREEBET_STAKE = 8;
export var EXISTING_ACTIVE_STAKE = 9;
export var NO_BIG_STAKE_PERMISSION = 10;
export var FREEBET_BIG_STAKE = 11;
export var ALTERNATIVE_STAKE = 12;
export var NOT_POSSIBLE_STAKE = 13;
export var LIMIT_EXCEEDED = -19;



// WEBPACK FOOTER //
// ./src/constants/BetCreateErrorStatus.js